<template>
  <div class="noData">
    <img src="@/assets/noData.png" alt="" class="mb10">
    <div class="c9">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default() {
        return '暂无数据'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.noData{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  flex-direction: column;
  img{
    width: 100px;
  }
}
</style>
